import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune_cscommunity_reason.jpg'

const paperInfo = {
    paperName: 'カスタマーサクセスに「コミュニティ」が必要な4つの理由',
    thumbnail,
    feature1: 'カスタマーサクセスとコミュニティの密接な関係性',
    feature2: 'なぜカスタマーサクセスにコミュニティが必要なのか',
    feature3: 'コミュニティ施策をとることでどのような効果が期待できるか',
    description:
        'コミュニティ施策は幅広い用途で検討が推進されていますが、その中でも特にカスタマーサクセス文脈で、ユーザーエンゲージメント / ロイヤルティを高める目的での導入が進んでいます。今回はカスタマーサクセスにおけるコミュニティの役割を導入事例を交えて紹介しています。',
    formSrc: 'https://go.commmune.jp/l/915341/2022-06-09/hdc8n',
    type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
    return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
